import { render, staticRenderFns } from "./ScreenConfiguracion.vue?vue&type=template&id=e6d71066"
import script from "./ScreenConfiguracion.vue?vue&type=script&lang=js"
export * from "./ScreenConfiguracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports